import camelCase from 'lodash/camelCase';

const vars = {};

try {
	const { customProperties } = require('./variables');
	Object.keys(customProperties).forEach(key => {
		vars[camelCase(key)] = customProperties[key];
	});
} catch (e) {
	throw new Error('please run `gatsby develop` at least once before running `gatsby build`.');
}

export default vars;
